export default __webpack_public_path__ + "ac2c7f563cc5f1211b8fa5ac085d60c3.glb";